import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useRemarksList() {
  // Use toast
  const toast = useToast();

  const refRemarkListTable = ref(null);

  // Table Handlers
  const tableColumns = [
   /*  { key: "id", label: "編號", sortable: true }, */
    { key: "sort_order", label: "排序", sortable: true , class: "sticky-column"},
    { key: "remark_type.name", label: "類型", class: "sticky-column"},
    { key: "actions", label: "操作", class: "sticky-column" },
    { key: "title", label: "標題", sortable: true },
    { key: "content", label: "內容", sortable: true, class: 'pre-wrap mw-300' },
    { key: "is_active", label: "狀態", sortable: true },
    { key: "updated_at", label: "修改日期", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refRemarkListTable.value
      ? refRemarkListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refRemarkListTable.value.refresh();
  };

  const remarksList = ref(null);

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchRemarks = (ctx, callback) => {
     store
       .dispatch("remark/fetchRemarks", {
         q: searchQuery.value,
         perPage: perPage.value,
         page: currentPage.value,
         sortBy: sortBy.value,
         sortDesc: isSortDirDesc.value,
       })
       .then((response) => {
         const { remarks, total } = response.data;
         callback(remarks);
         totalRow.value = total;
         remarksList.value = remarks
       })
       .catch((err) => {
         console.log(err);
         toast({
           component: ToastificationContent,
           props: {
             title: "獲取備註清單時出錯",
             icon: "AlertTriangleIcon",
             variant: "danger",
           },
         });
       });
  };

  const remarkTypeOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        remark_types: true
      })
      .then((response) => {
        remarkTypeOptions.value = response.data.remark_types;
      });
  };


  onMounted(() => {
    refetchOption();
  });

  return {
    fetchRemarks,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    remarksList,
    refRemarkListTable,
    ability,
    refetchData,
    remarkTypeOptions,
  };
}
